import { Maybe } from '@/utils/types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'brand_landing'
type ItemType = 'ContentLivestream'

/**
 * Interaction builder for livestreams in the extras tab
 * Used for tracking user interactions with livestream content
 */
export class ExtrasTabItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<ItemType>; attribution: unknown }) {
    super(item)
  }
}
